// hooks/useUserCountry.js or similar

import { useEffect, useState } from "react";

const getUserCountryByGeolocation = () => {
  if (!navigator.geolocation) {
    return Promise.resolve("AU");
  }

  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;

        try {
          const response = await fetch(
            `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
          );
          const data = await response.json();
          resolve(data.countryCode || "AU");
        } catch {
          resolve("AU");
        }
      },
      () => resolve("AU") // Permission denied or error
    );
  });
};

export const useUserCountry = () => {
  const [country, setCountry] = useState("AU");

  useEffect(() => {
    getUserCountryByGeolocation().then(setCountry);
  }, []);

  return country;
};
